module.exports = __webpack_public_path__ + "img/symbol_7.cec3f79d.png";